/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
// page
import WeeklyWorkSchedule from "./Component/WeeklyWorkSchedule";
import DailyWorkSchedule from "./Component/DailyWorkSchedule";
// component
import Input from "../../../components/Input";
import Counter from "../../../components/Counter";
import Modal, { ModalHeader } from "../../../components/Modal";
import Radios from "../../../components/Radio/Radios";
import CheckBox from "../../../components/CheckBox/CheckBox";
import Button from "../../../components/Button";
import Select from "../../../components/Select";
import IconButton from "../../../components/Button/IconButton";
import Profile from "../../../components/Profile";
// icon
import PersonIcon from "../../../assets/images/icon/person-icon.svg";
//utils
import { forEach, get, isEmpty, isNumber } from "lodash";
import { getFutureDay } from "../../../utils/date";
import { searchEmployee } from "../../../utils/employee";
// api
import { getWorkPlacesList } from "../../../apis/work-places";
import {
  createWorkSchedule,
  deleteWorkSchedule,
  modifyWorkSchedule,
} from "../../../apis/work-schedule";
import { useSelector } from "react-redux";
import DatePicker from "../../../components/DatePicker";
import systemAlert from "../../../utils/systemAlert";
import { findModeLabel } from "../../../utils/mode";

import { toast } from '../../../utils/toast';


export const getWorkSchedule = async () => {
  const workPlaceListData = await getWorkPlacesList({
    offset: 0,
    limit: 999,
  });

  const workPlaceList = [
    { label: "지정하지 않음", value: "" },
    ...get(workPlaceListData, "data.places", []).map(
      (item) => ({
        label: item.placeName,
        value: String(item.idx),
      })
    )
  ]

  return {
    workPlaceList,
  };
};

const Management = ({
  mode,
  setMode,
  open,
  setOpen,
  submit,
  formData,
  setFormData,
}) => {
  const { employees } = useSelector((store) => ({
    employees: store.Data.employees,
  }));
  const [workSchedule, setWorkSchedule] = useState(null);
  const [form, setForm] = useState({
    workPlaceIdx: "",
    title: "",
    commuteType: "fixed",
    scheduleType: "weekly",
    dailySchedulePoint: getFutureDay(1),
    weeklyMaxExtendWorkHour: 12,
    nightWorkStartTime: "22:00:00",
    nightWorkEndTime: "06:00:00",
    isCommonHolidayApplied: true,
    isCommutePlaceAlarm: "1",
    targetCommutePlaceAlarm: {
      isAlarmPartLeader: false,
      employeeIdxList: [],
    },
    isCommuteTimeAlarm: "1",
    targetCommuteTimeAlarm: {
      isAlarmPartLeader: false,
      employeeIdxList: [],
    },
  });
  const [initForm] = useState({
    workPlaceIdx: "",
    title: "",
    commuteType: "fixed",
    scheduleType: "weekly",
    dailySchedulePoint: getFutureDay(1),
    weeklyMaxExtendWorkHour: 12,
    nightWorkStartTime: "22:00:00",
    nightWorkEndTime: "06:00:00",
    isCommonHolidayApplied: true,
    isCommutePlaceAlarm: "1",
    targetCommutePlaceAlarm: {
      isAlarmPartLeader: false,
      employeeIdxList: [],
    },
    isCommuteTimeAlarm: "1",
    targetCommuteTimeAlarm: {
      isAlarmPartLeader: false,
      employeeIdxList: [],
    },
  });
  const [weeklySchedule, setWeeklySchedule] = useState([
    {
      day: "sunday",
      dayType: "holiday",
      label: "일",
      workStart: "09:00:00",
      workEnd: "18:00:00",
      restTimes: [
        {
          restStart: "12:00:00",
          restEnd: "13:00:00",
        },
      ],
    },
    {
      day: "monday",
      dayType: "workday",
      label: "월",
      workStart: "09:00:00",
      workEnd: "18:00:00",
      restTimes: [
        {
          restStart: "12:00:00",
          restEnd: "13:00:00",
        },
      ],
    },
    {
      day: "tuesday",
      dayType: "workday",
      label: "화",
      workStart: "09:00:00",
      workEnd: "18:00:00",
      restTimes: [
        {
          restStart: "12:00:00",
          restEnd: "13:00:00",
        },
      ],
    },
    {
      day: "wednesday",
      dayType: "workday",
      label: "수",
      workStart: "09:00:00",
      workEnd: "18:00:00",
      restTimes: [
        {
          restStart: "12:00:00",
          restEnd: "13:00:00",
        },
      ],
    },
    {
      day: "thursday",
      dayType: "workday",
      label: "목",
      workStart: "09:00:00",
      workEnd: "18:00:00",
      restTimes: [
        {
          restStart: "12:00:00",
          restEnd: "13:00:00",
        },
      ],
    },
    {
      day: "friday",
      dayType: "workday",
      label: "금",
      workStart: "09:00:00",
      workEnd: "18:00:00",
      restTimes: [
        {
          restStart: "12:00:00",
          restEnd: "13:00:00",
        },
      ],
    },
    {
      day: "saturday",
      dayType: "holiday",
      label: "토",
      workStart: "09:00:00",
      workEnd: "18:00:00",
      restTimes: [
        {
          restStart: "12:00:00",
          restEnd: "13:00:00",
        },
      ],
    },
  ]);
  const [initWeeklySchedule] = useState([
    {
      day: "sunday",
      dayType: "holiday",
      label: "일",
      workStart: "09:00:00",
      workEnd: "18:00:00",
      restTimes: [
        {
          restStart: "12:00:00",
          restEnd: "13:00:00",
        },
      ],
    },
    {
      day: "monday",
      dayType: "workday",
      label: "월",
      workStart: "09:00:00",
      workEnd: "18:00:00",
      restTimes: [
        {
          restStart: "12:00:00",
          restEnd: "13:00:00",
        },
      ],
    },
    {
      day: "tuesday",
      dayType: "workday",
      label: "화",
      workStart: "09:00:00",
      workEnd: "18:00:00",
      restTimes: [
        {
          restStart: "12:00:00",
          restEnd: "13:00:00",
        },
      ],
    },
    {
      day: "wednesday",
      dayType: "workday",
      label: "수",
      workStart: "09:00:00",
      workEnd: "18:00:00",
      restTimes: [
        {
          restStart: "12:00:00",
          restEnd: "13:00:00",
        },
      ],
    },
    {
      day: "thursday",
      dayType: "workday",
      label: "목",
      workStart: "09:00:00",
      workEnd: "18:00:00",
      restTimes: [
        {
          restStart: "12:00:00",
          restEnd: "13:00:00",
        },
      ],
    },
    {
      day: "friday",
      dayType: "workday",
      label: "금",
      workStart: "09:00:00",
      workEnd: "18:00:00",
      restTimes: [
        {
          restStart: "12:00:00",
          restEnd: "13:00:00",
        },
      ],
    },
    {
      day: "saturday",
      dayType: "holiday",
      label: "토",
      workStart: "09:00:00",
      workEnd: "18:00:00",
      restTimes: [
        {
          restStart: "12:00:00",
          restEnd: "13:00:00",
        },
      ],
    },
  ]);
  const [dailySchedule, setDailySchedule] = useState([
    {
      counter: 1,
      dayType: "workday",
      workStart: "09:00:00",
      workEnd: "18:00:00",
      restTimes: [
        {
          restStart: "12:00:00",
          restEnd: "13:00:00",
        },
      ],
    },
  ]);
  const [initDailySchedule] = useState([
    {
      counter: 1,
      dayType: "workday",
      workStart: "09:00:00",
      workEnd: "18:00:00",
      restTimes: [
        {
          restStart: "12:00:00",
          restEnd: "13:00:00",
        },
      ],
    },
  ]);
  const [targetCommutePlaceAlarm, setTargetCommutePlaceAlarm] = useState([]);
  const [targetCommuteTimeAlarm, setTargetCommuteTimeAlarm] = useState([]);

  const _setWorkSchedule = async () => {
    const _workSchedule = await getWorkSchedule();
    setWorkSchedule(_workSchedule);
  };

  useEffect(() => {
    setForm(initForm);
  }, [initForm]);

  useEffect(() => {
    if (formData && mode !== "create") {
      if (formData.scheduleType === "weekly") {
        setForm({
          ...formData,
          workPlaceIdx: isNumber(formData.workPlaceIdx) ? String(formData.workPlaceIdx) : formData.workPlaceIdx,
          weeklyMaxExtendWorkHour: Number(
            formData.weeklyMaxExtendWorkHour.slice(0, 2)
          ),
          isCommutePlaceAlarm: formData.isCommutePlaceAlarm ? "1" : "0",
          isCommuteTimeAlarm: formData.isCommuteTimeAlarm ? "1" : "0",
        });

        formData.schedule = formData.schedule.map((s) => ({
          ...s,
          workStart: s.workStart || "09:00:00",
          workEnd: s.workEnd || "18:00:00",
          restTimes: s.restTimes || [
            { restStart: "12:00:00", restEnd: "13:00:00" },
          ],
        }));
        setWeeklySchedule(formData.schedule);
      }

      if (formData.scheduleType === "daily") {
        setForm({
          ...formData,
          workPlaceIdx: isNumber(formData.workPlaceIdx) ? String(formData.workPlaceIdx) : formData.workPlaceIdx,
          weeklyMaxExtendWorkHour: Number(
            formData.weeklyMaxExtendWorkHour.slice(0, 2)
          ),
          isCommutePlaceAlarm: formData.isCommutePlaceAlarm ? "1" : "0",
          isCommuteTimeAlarm: formData.isCommuteTimeAlarm ? "1" : "0",
        });

        // TODO daily 타입 프론트 표현 어떻게...?!
        formData.schedule = formData.schedule.map((s) => ({
          ...s,
          counter: 1,
          workStart: s.workStart || "09:00:00",
          workEnd: s.workEnd || "18:00:00",
          restTimes: s.restTimes || [
            { restStart: "12:00:00", restEnd: "13:00:00" },
          ],
        }));

        setDailySchedule(formData.schedule);
      }

      if (!isEmpty(get(formData, "targetCommutePlaceAlarm.employeeIdxList"))) {
        const targetList = get(
          formData,
          "targetCommutePlaceAlarm.employeeIdxList"
        );
        let targetEmployees = [];
        forEach(targetList, (target) => {
          targetEmployees.push(employees.find(
            (employee) => employee.idx === target
          ))
        });
        setTargetCommutePlaceAlarm(targetEmployees);
      } else {
        setTargetCommutePlaceAlarm([]);
      }

      if (!isEmpty(get(formData, "targetCommuteTimeAlarm.employeeIdxList"))) {
        const targetList = get(
          formData,
          "targetCommuteTimeAlarm.employeeIdxList"
        );
        let targetEmployees = [];
        forEach(targetList, (target) => {
          targetEmployees.push(employees.find(
            (employee) => employee.idx === target
          ))
        });
        setTargetCommuteTimeAlarm(targetEmployees);
      } else {
        setTargetCommuteTimeAlarm([]);
      }
    }
  }, [formData, mode]);

  useEffect(() => {
    _setWorkSchedule();
  }, []);

  useEffect(() => {
    if (!isEmpty(targetCommutePlaceAlarm)) {
      const list = targetCommutePlaceAlarm.map((employee) => {
        return employee.idx;
      });

      setForm({
        ...form,
        targetCommutePlaceAlarm: {
          ...form.targetCommutePlaceAlarm,
          employeeIdxList: list,
        },
      });
    } else {
      setForm({
        ...form,
        targetCommutePlaceAlarm: {
          ...form.targetCommutePlaceAlarm,
          employeeIdxList: [],
        },
      });
    }
  }, [targetCommutePlaceAlarm]);

  useEffect(() => {
    if (!isEmpty(targetCommuteTimeAlarm)) {
      const list = targetCommuteTimeAlarm.map((employee) => {
        return employee.idx;
      });

      setForm({
        ...form,
        targetCommuteTimeAlarm: {
          ...form.targetCommuteTimeAlarm,
          employeeIdxList: list,
        },
      });
    } else {
      setForm({
        ...form,
        targetCommuteTimeAlarm: {
          ...form.targetCommuteTimeAlarm,
          employeeIdxList: [],
        },
      });
    }
  }, [targetCommuteTimeAlarm]);

  const handleSubmit = (e) => {
    e.preventDefault();
    let transForm = {};

    if (isEmpty(form.title) || (form.title.length > 100)) return toast.error('근무일정구분은 필수입니다.(100글자 이내)')

    if (form.scheduleType === "weekly") {
      transForm = {
        ...form,
        workPlaceIdx: !isEmpty(form.workPlaceIdx) ? Number(form.workPlaceIdx) : null,
        isCommutePlaceAlarm: Boolean(Number(form.isCommutePlaceAlarm)),
        isCommuteTimeAlarm: Boolean(Number(form.isCommuteTimeAlarm)),
        weeklyMaxExtendWorkHour: `${("0" + form.weeklyMaxExtendWorkHour).slice(
          -2
        )}:00:00`,
        schedule: weeklySchedule.map((schedule) => {
          if (schedule.dayType === "holiday") {
            return {
              day: schedule.day,
              dayType: "holiday",
            };
          } else {
            return {
              day: schedule.day,
              dayType: schedule.dayType,
              restTimes: schedule.restTimes,
              workEnd: schedule.workEnd,
              workStart: schedule.workStart,
            };
          }
        }),
      };

      delete transForm["dailySchedulePoint"];
    }

    if (form.scheduleType === "daily") {
      const transSchedule = [];

      forEach(dailySchedule, (daily) => {
        for (let i = 0; i < daily.counter; i++) {
          transSchedule.push(daily);
        }
      });

      transForm = {
        ...form,
        workPlaceIdx: !isEmpty(form.workPlaceIdx) ? Number(form.workPlaceIdx) : null,
        isCommutePlaceAlarm: Boolean(Number(form.isCommutePlaceAlarm)),
        isCommuteTimeAlarm: Boolean(Number(form.isCommuteTimeAlarm)),
        weeklyMaxExtendWorkHour: `${("0" + form.weeklyMaxExtendWorkHour).slice(
          -2
        )}:00:00`,
        schedule: transSchedule.map((schedule, index) => {
          if (schedule.dayType === "holiday") {
            return {
              day: index + "",
              dayType: "holiday",
            };
          } else {
            return {
              day: index + "",
              dayType: schedule.dayType,
              restTimes: schedule.restTimes,
              workEnd: schedule.workEnd,
              workStart: schedule.workStart,
            };
          }
        }),
      };
    }

    const modeText = mode === "create" ? '등록' : '수정'
    systemAlert(
      `"${transForm.title}" 근무 일정을 ${modeText}하시겠습니까?`, {
      buttons: [
        {
          color: 'text',
          label: '취소'
        },
        {
          label: modeText,
          onClick: () => {
            if (mode === "create") {
              createWorkSchedule(transForm).then(() => {
                cancel();
                submit();
              });
            }
            if (mode === "modify") {
              modifyWorkSchedule(formData.idx, transForm).then(() => {
                cancel();
                submit();
              });
            }
          }
        }
      ]
    })
  };

  const cancel = (e) => {
    // e.preventDefault();
    setOpen(false);
    setMode("create");
    if (mode === "modify") {
      setForm(initForm);
      setWeeklySchedule(initWeeklySchedule);
      setDailySchedule(initDailySchedule);
      setFormData({});
    }
  };

  const handleOnCheck = (checked) => {
    setForm({
      ...form,
      isCommonHolidayApplied: checked ? false : true
    });
  };

  const handleOnChange = (e) => {
    const { name, value } = e.target;
    setForm({ ...form, [name]: value });
  };

  const openPlaceAlarmEmployees = () => {
    searchEmployee((employees) => {
      setTargetCommutePlaceAlarm(employees);
    }, targetCommutePlaceAlarm);
  };

  const openTimeAlarmEmployees = () => {
    searchEmployee((employees) => {
      setTargetCommuteTimeAlarm(employees);
    }, targetCommuteTimeAlarm);
  };

  const handleOnRemove = () => {
    const modeText = '삭제'
    systemAlert(
      `"${formData.title}" 근무 일정을 ${modeText}하시겠습니까?`, {
      buttons: [
        {
          color: 'text',
          label: '취소'
        },
        {
          label: modeText,
          onClick: () => {
            deleteWorkSchedule(formData.idx).then((res) => {
              cancel();
              submit();
            });
          }
        }
      ]
    })
  };

  return (
    <Modal isOpen={open} close={cancel} type="fit">
      <div className="work-schedule-write">
        <div className="work-schedule-title-wrap">
          {mode === "modify" && (
            <Button
              className="float-right"
              label="삭제"
              color="line"
              action={handleOnRemove}
            />
          )}
          <ModalHeader>
            근무일정 {findModeLabel(mode)}
          </ModalHeader>
        </div>
        <div className="work-schedule-top-wrap">
          <div className="work-schedule-form-wrap">
            <label className="work-schedule-form-label">근무일정 구분</label>
            <Input
              name="title"
              value={form.title}
              className="work-schedule-form-input"
              placeholder="예) 고정근무제, 3조 2교대"
              onChange={handleOnChange}
              readOnly={mode === 'view'}
            />
          </div>
          <div className="work-schedule-form-wrap">
            {/* 무조건 지정된 시간  */}
            <label className="work-schedule-form-label">출퇴근 유형</label>
            <Radios
              className="work-schedule-form-radio"
              field={{
                key: "commuteType",
                type: "radio",
                options: {
                  list: [
                    { label: "고정근무제", value: "fixed" },
                    { label: "유연근무제", value: "free" },
                  ],
                },
                defaultChecked: form.commuteType,
                onChange: handleOnChange,
              }}
            />
            <label className="work-schedule-form-label">적용 단위</label>
            <Radios
              className="work-schedule-form-radio"
              field={{
                key: "scheduleType",
                type: "radio",
                options: {
                  list: [
                    { label: "요일별", value: "weekly" },
                    { label: "특정일 반복", value: "daily" },
                  ],
                },
                defaultChecked: form.scheduleType,
                onChange: handleOnChange,
              }}
              mode={mode}
            />
            {form.scheduleType === "daily" && (
              <>
                <label className="work-schedule-form-label margin-left-28">
                  반복 시작일
                </label>
                <DatePicker
                  field={{
                    key: "dailySchedulePoint",
                  }}
                  defaultValue={form.dailySchedulePoint}
                  onChange={(date) => {
                    setForm({
                      ...form,
                      dailySchedulePoint: date.dailySchedulePoint.toString(),
                    });
                  }}
                  disabled={mode === 'view'}
                />
              </>
            )}
          </div>
        </div>
        {form.scheduleType === "weekly" && (
          <WeeklyWorkSchedule
            dayList={weeklySchedule}
            setDayList={setWeeklySchedule}
            mode={mode}
          />
        )}
        {form.scheduleType === "daily" && (
          <DailyWorkSchedule
            dayList={dailySchedule}
            setDayList={setDailySchedule}
            mode={mode}
          />
        )}
        <div className="work-schedule-middle-wrap">
          {/* <div className="inline-block">
            <label className="work-schedule-counter-label">소정근로시간</label>
            <Counter
              className="work-schedule-form-counter"
              field={{
                label: "하루",
                unit: "시간",
                handleChange: (data) => {
                  console.log(data);
                },
              }}
              data={8}
            />
          </div> */}
          <div className="inline-block">
            <label className="work-schedule-counter-label">
              최장 연장근무시간
            </label>
            <Counter
              className="work-schedule-form-counter"
              field={{
                key: "weeklyMaxExtendWorkHour",
                label: "한 주",
                unit: "시간",
                handleChange: (data, field) => {
                  setForm({ ...form, [field.key]: data[field.key] });
                },
              }}
              data={form.weeklyMaxExtendWorkHour}
              disabled={mode === 'view'}
            />
          </div>
          <div className="work-schdule-form-checkbox">
            <CheckBox
              label="공통휴일 미적용"
              onChange={handleOnCheck}
              checked={!form.isCommonHolidayApplied}
              disabled={mode === 'view'}
            />
          </div>
        </div>
        <div className="work-schedule-bottom-wrap">
          <p className="bottom-section-title">출퇴근 체크</p>
          <div className="work-schedule-form-wrap">
            <label className="work-schedule-form-label">출퇴근 위치</label>
            <Select
              name="workPlaceIdx"
              className="work-schedule-form-select"
              onChange={handleOnChange}
              list={get(workSchedule, "workPlaceList")}
              value={get(form, "workPlaceIdx")}
              disabled={mode === 'view'}
            />
          </div>
          <div className="work-schedule-form-wrap">
            <label className="work-schedule-form-label">위치 불일치</label>
            <Radios
              className="work-schedule-form-radio"
              field={{
                key: "isCommutePlaceAlarm",
                type: "radio",
                options: {
                  list: [
                    { label: "불일치 알림", value: "1" },
                    { label: "알리지 않음", value: "0" },
                  ],
                },
                onChange: handleOnChange,
                defaultChecked: form.isCommutePlaceAlarm,
              }}
              disabled={mode === 'view'}
            />
            <label className="work-schedule-form-label margin-left-28">
              지각, 조퇴 체크
            </label>
            <Radios
              className="work-schedule-form-radio"
              field={{
                key: "isCommuteTimeAlarm",
                type: "radio",
                options: {
                  list: [
                    { label: "체크함", value: "1" },
                    { label: "체크안함", value: "0" },
                  ],
                },
                onChange: handleOnChange,
                defaultChecked: form.isCommuteTimeAlarm,
              }}
              disabled={mode === 'view'}
            />
          </div>
          <div className="work-schedule-alarm-wrap">
            <p className="bottom-section-title">알림대상</p>
            <div className="work-shcedule-alarm-checkboxes-wrap">
              {/* <CheckBox
                label="부서장"
                onChange={(checked) => {
                  setForm({
                    ...form,
                    targetCommutePlaceAlarm: {
                      ...form.targetCommutePlaceAlarm,
                      isAlarmPartLeader: checked,
                    },
                  });
                }}
                checked={get(form, "targetCommutePlaceAlarm.isAlarmPartLeader")}
                disabled={mode === 'view'}
              /> */}
              <CheckBox
                className="margin-left-16"
                label="특정인"
                onChange={(checked) => {
                  if (checked) {
                    openPlaceAlarmEmployees();
                  } else {
                    setTargetCommutePlaceAlarm([]);
                  }
                }}
                checked={
                  !isEmpty(get(form, "targetCommutePlaceAlarm.employeeIdxList"))
                }
                disabled={mode === 'view'}
              />
              {mode !== 'view' && (
                <IconButton
                  className="work-schedule-person-search-btn"
                  icon={PersonIcon}
                  label="사람 선택"
                  labelClassName="icon-label"
                  onClick={openPlaceAlarmEmployees}
                />
              )}
            </div>
            {!isEmpty(form.targetCommutePlaceAlarm.employeeIdxList) &&
              form.targetCommutePlaceAlarm.employeeIdxList.map((employee, idx) => (
                <div key={idx}>
                  <Profile employeeIdx={employee} isPreview={false} />
                </div>
              ))}
          </div>
          <div className="work-schedule-alarm-wrap">
            <p className="bottom-section-title">알림대상</p>
            <div className="work-shcedule-alarm-checkboxes-wrap">
              {/* <CheckBox
                label="부서장"
                onChange={(checked) => {
                  setForm({
                    ...form,
                    targetCommuteTimeAlarm: {
                      ...form.targetCommuteTimeAlarm,
                      isAlarmPartLeader: checked,
                    },
                  });
                }}
                checked={get(form, "targetCommuteTimeAlarm.isAlarmPartLeader")}
                disabled={mode === 'view'}
              /> */}
              <CheckBox
                className="margin-left-16"
                label="특정인"
                onChange={(checked) => {
                  if (checked) {
                    openTimeAlarmEmployees();
                  } else {
                    setTargetCommuteTimeAlarm([]);
                  }
                }}
                checked={
                  !isEmpty(get(form, "targetCommuteTimeAlarm.employeeIdxList"))
                }
                disabled={mode === 'view'}
              />
              {mode !== 'view' && (
                <IconButton
                  className="work-schedule-person-search-btn"
                  icon={PersonIcon}
                  label="사람 선택"
                  labelClassName="icon-label"
                  onClick={openTimeAlarmEmployees}
                />
              )}
            </div>
            {!isEmpty(form.targetCommuteTimeAlarm.employeeIdxList) &&
              form.targetCommuteTimeAlarm.employeeIdxList.map((employee, idx) => (
                <div key={idx}>
                  <Profile employeeIdx={employee} isPreview={false} />
                </div>
              ))}
          </div>
        </div>
        <div className="form-button-wrap">
          <Button className="form-button" color={"text"} onClick={cancel}>
            취소
          </Button>
          {mode !== 'view' && (
            <Button className="form-button" onClick={handleSubmit}>
              작성완료
            </Button>
          )}
        </div>
      </div>
    </Modal>
  );
};

export default Management;
